import PageLayout from "../components/site/PageLayout";
import { SectionHeading } from "../components/site/SectionHeading";

const Privacy = () => (
  <PageLayout title="Privacy Policy">
    <section className="pt-16 pb-24">
      <div className="container-tt max-w-3xl prose prose-stone">
        <SectionHeading eyebrow="Legal" title="Privacy Policy" description="Last updated: February 2026" />
        <div className="mt-10 space-y-6 text-stone/85 leading-relaxed">
          <p>TechTies ("we", "us") is a student-led nonprofit organization in Orange County, California. This policy explains what information we collect, how we use it, and how we protect it.</p>
          <h3 className="font-display text-2xl">What we collect</h3>
          <p>When you fill out a form on this website (volunteer, contact, partnership, or newsletter), we collect the information you provide — such as your name, email, phone number, school, and any message you send us.</p>
          <h3 className="font-display text-2xl">How we use it</h3>
          <p>We use your information only to respond to your inquiry, coordinate volunteer opportunities, or send you occasional updates if you opted in. We do not sell your data. We do not share it with third parties for marketing.</p>
          <h3 className="font-display text-2xl">How we store it</h3>
          <p>Form submissions are stored securely in our organization's database, accessible only to TechTies leads.</p>
          <h3 className="font-display text-2xl">Your rights</h3>
          <p>You can ask us to update or delete your information at any time by emailing us at the address on our Contact page.</p>
        </div>
      </div>
    </section>
  </PageLayout>
);
export default Privacy;
